<script>
  import { onMount } from 'svelte';
  import { marked } from 'marked';

  let scrollY;

  let data = {};

  let entries = [];
  let filteredEntries = []

  const OWNER_SDK = 'Unity';
  const OWNER_SDK_SERVER = 'Unity Server';
  const OWNER_SDK_SERVER_RUNTIME = 'Server';
  const OWNER_CLI = 'CLI';
  const OWNER_WEB_SDK = 'Web';
  const OWNER_PORTAL = 'Portal';
  const OWNER_API = 'API';

  const urlParams = new URLSearchParams(window.location.search);

  let tabs = [
    {
      name: 'CLI & Server',
      queryArg: 'cli',
      active: true,
      owners: [OWNER_CLI, OWNER_SDK_SERVER_RUNTIME]
    },
    {
      name: 'API',
      queryArg: 'api',
      active: true,
      owners: [OWNER_API]
    },
    {
      name: 'Portal',
      queryArg: 'portal',
      active: true,
      owners: [OWNER_PORTAL]
    },
    {
      name: 'Web SDK',
      queryArg: 'web',
      active: true,
      owners: [OWNER_WEB_SDK]
    },
    {
      name: 'Unity SDK',
      queryArg: 'unity',
      active: true,
      owners: [OWNER_SDK, OWNER_SDK_SERVER]
    },
    {
      name: 'Unreal SDK',
      owners: [],
      queryArg: 'unreal',
      link: 'https://help.beamable.com/Unreal-Latest/' // TODO; it would be nice to point to the latest whats-new section
    }
  ];
  tabs.forEach(tab => {
    tab.active = urlParams.has(tab.queryArg)
  });

  let ownerEnabledMap = {}
  $: ownerEnabledMap = tabs.reduce( (agg, next) => {
  
    next.owners.map(owner => agg[owner] = next.active)
    return agg;
  }, {});

  let noSelection = false;
  $: noSelection = Object.values(ownerEnabledMap).filter(x => x).length == 0
  $: filteredEntries = entries.filter(e => ownerEnabledMap[e.owner]);

  let blogPosts = {
    ['1.6.2']: {
      desc: 'Check out the November blog post.',
      url: 'https://beamable.com/blog/beamable-sdk-review-november-2022'
    },

    ['1.5.2']: {
      desc: 'Check out the October blog post.',
      url: 'https://beamable.com/blog/beamable-sdk-review-october-2022'
    },

    ['1.3.0']: {
      desc: 'Check out the blogpost.',
      url: 'https://beamable.com/blog/beamable-release-unity-sdk-1-3-0'
    },
    ['1.2.0']: {
      desc: 'Check out the blogpost.',
      url: 'https://beamable.com/blog/beamable-release-unity-sdk-1-2-0'
    },
    ['1.1.0']: {
      desc: 'Check out the blogpost.',
      url: 'https://beamable.com/blog/beamable-release-unity-sdk-1-1-0'
    },
    ['1.0.0']: {
      desc: 'Check out the blogpost.',
      url: 'https://beamable.com/blog/beamable-release-unity-sdk-1-0-0'
    },
    ['0.18.0']: {
      desc: 'Check out the blogpost.',
      url: 'https://beamable.com/blog/beamable-release-unity-sdk-0-18-0'
    },
    ['0.17.0']: {
      desc: 'Check out the blogpost.',
      url: 'https://beamable.com/blog/beamable-release-unity-sdk-0-17-0'
    },
    ['CLI & Server 3.0.0']: {
      desc: 'Beamable Mercury blog post',
      url: 'https://beamable.com/blog/beamable-mercury-our-latest-release'
    },
    ['CLI & Server 3.0.1']: {
      desc: 'Beamable Mercury blog post',
      url: 'https://beamable.com/blog/beamable-mercury-our-latest-release'
    },
    ['Unity SDK 2.0.0']: {
      desc: 'Beamable Mercury blog post',
      url: 'https://beamable.com/blog/beamable-mercury-our-latest-release'
    },
  }
  
  let decorations = [
    {
      url: 'https://beamable.com/wp-content/themes/beamable/images/portal-images/cube04.svg',
      right: 'min(7.4%, 30px)',
      width: '240px',
      y: 400,
      speed: .1,
      rotSpeed: -.01,
      rotStart: 1
    },
    {
      url: 'https://beamable.com/wp-content/themes/beamable/images/portal-images/cube03.svg',
      right: '1%',
      width: '100px',
      y: 100,
      speed: .53,
      rotSpeed: .02,
      rotStart: 1
    },
    {
      url: 'https://beamable.com/wp-content/themes/beamable/images/portal-images/cube02.svg',
      right: '2%',
      width: '100px',
      y: 900,
      speed: .5,
      rotSpeed: .01,
      rotStart: -43
    },
    {
      url: 'https://beamable.com/wp-content/themes/beamable/images/portal-images/cube01.svg',
      right: '6%',
      width: '130px',
      y: 1100,
      speed: .8,
      rotSpeed: .01,
      rotStart: -1
    },
    {
      url: 'https://beamable.com/wp-content/themes/beamable/images/portal-images/cube03.svg',
      right: '5%',
      width: '100px',
      y: 1800,
      speed: .75,
      rotSpeed: -.009,
      rotStart: 1
    },
    {
      url: 'https://beamable.com/wp-content/themes/beamable/images/portal-images/cube02.svg',
      right: '93%',
      width: '100px',
      y: 2300,
      speed: .6,
      rotSpeed: .01,
      rotStart: -43
    },
    {
      url: 'https://beamable.com/wp-content/themes/beamable/images/portal-images/cube01.svg',
      right: '92%',
      width: '130px',
      y: 2000,
      speed: .83,
      rotSpeed: .0,
      rotStart: -1
    },
    {
      url: 'https://beamable.com/wp-content/themes/beamable/images/portal-images/cube04.svg',
      right: '6%',
      width: '130px',
      y: 4000,
      speed: .7,
      rotSpeed: .02,
      rotStart: -3
    },
    {
      url: 'https://beamable.com/wp-content/themes/beamable/images/portal-images/cube03.svg',
      right: '2%',
      width: '100px',
      y: 4400,
      speed: .73,
      rotSpeed: .02,
      rotStart: -3
    },
  ]

  const UNRELEASED = 'In Development'

function clickTab(tab){
    tab = {...tab, active: !tab.active}

    if (tab.link){
      window.open(tab.link, '_blank');
      return;
    }

    if (!tab.active){
      urlParams.delete(tab.queryArg);
    } else {
      urlParams.set(tab.queryArg, '');
    }

    var url = window.location.pathname + "?" + urlParams.toString().replaceAll('=', '');
    history.replaceState(null, null, window.location.pathname + "?" + urlParams.toString().replaceAll('=', ''));
    
    return tab; 
  }

  function dateSorter(a, b) {

    if (a.owner == b.owner){
      return semanticSorter(a,b);
    }

    var aDate = new Date(a.releaseDate)
    var bDate = new Date(b.releaseDate)

    if (aDate > bDate){
      return -1;
    } else if (aDate < bDate){
      return 1;
    } else {
      return semanticSorter(a,b);
    }
  }

  function semanticSorter(a, b){
    if (a.version.endsWith(UNRELEASED)) return -1;
    if (b.version.endsWith(UNRELEASED)) return 1;
    if (a.major != b.major) return a.major > b.major ? -1 : 1
    if (a.minor != b.minor) return a.minor > b.minor ? -1 : 1
    if (a.patch != b.patch) return a.patch > b.patch ? -1 : 1
    return 0;
  }

  function createRenderer(owner){
    var major, minor, patch, version, changeType;
    var month, year, day, dateString, dateStringTooltip;

    return {
      listitem(text) {
        var tag = owner;
        if (owner == OWNER_SDK_SERVER){
          tag = OWNER_SDK_SERVER_RUNTIME;
        }
        return `<li owner="${owner}" release-date="${dateString}" release-date-tooltip="${dateStringTooltip}" version="${version}" major="${major}" minor="${minor}" patch="${patch}" change-type="${changeType}"><span class="item-owner">[${tag}]</span> <span>${text}</span></li>`
      },
      heading(text, level) {
        const escapedText = text.toLowerCase().replace(/[^\w]+/g, '-');

        if (level == 2) { // this is a version header...

          var dateMatches = text.toLowerCase().match(/\]\s+\-\s+(\d+)\-(\d+)\-(\d+)/);
          if (dateMatches && dateMatches.length == 4) {
            year = dateMatches[1]
            month = dateMatches[2]
            day = dateMatches[3]
            dateString = year + '-' + month + '-' + day
            var monthString = [
              'January',
              'February',
              'March',
              'April',
              'May',
              'June',
              'July',
              'August',
              'September',
              'October',
              'November',
              'December'
            ][parseInt(month) - 1];
            dateStringTooltip = `${monthString} ${day}, ${year}`
          } else {
            dateString = ''
            dateStringTooltip = 'release date is unknown.'
          }

          if (escapedText.indexOf('unreleased') == -1 && owner != OWNER_API){
            var matches = text.toLowerCase().match(/\[(\d+)\.(\d+)\.(\d+)\]/);
            major = matches[1]
            minor = matches[2]
            patch = matches[3]

            version = `${major}.${minor}.${patch}`;
          } else {
            major = 0;
            minor = 0;
            patch = 0;
            version = UNRELEASED;
          }
          return `
                <h${level} owner="${owner}" release-date="${dateString}" version="${version}" major="${major}" minor="${minor}" patch="${patch}">
                  <a name="${version}" class="anchor" href="#${version}">
                    <span class="header-link"></span>
                  </a>
                  ${version}
                </h${level}>`
        } else if (level == 3) { // this is a change-type header...
          changeType = text.toLowerCase().replace(':', '');
          // return false;
          return ` <h${level} owner="${owner}" release-date="${dateString}" version="${version}" major="${major}" minor="${minor}" patch="${patch}" change-type="${changeType}">
              <a name="${escapedText}" class="anchor" href="#${escapedText}">
                <span class="header-link"></span>
              </a>
              ${escapedText}
            </h${level}>`
        }
        else {
          return false; // use default renderer
        }
      }
    };
  }

  async function getChanges(owner, url) {
    var res = await fetch(url)
    var text = await res.text();
    marked.use({ renderer: createRenderer(owner) });
    var html = marked.parse(text);
    var space = document.createElement('div');
    space.innerHTML = html;
    return space;
  }


  async function load() {


    const isStaging = urlParams.has('preview') || window.location.pathname == '/preview';
    const isDev = urlParams.has('dev') || window.location.pathname == '/dev'
    const isCi = urlParams.has('ci') || window.location.pathname == '/ci'


    var env = 'production';
    if (isStaging) env = 'staging';
    if (isDev) env = 'daily';
    if (isCi) env = 'ci';

    var portalEnv = {
      'production': 'support/3.0',
      'staging': 'master',
      'ci': 'develop',
      'daily': 'develop'
    }[env]

    var beamableChanges = await getChanges(OWNER_SDK, `https://raw.githubusercontent.com/beamable/Changelogs/${env}/com-beamable-changelog.md`)
    var beamableServerChanges = await getChanges(OWNER_SDK_SERVER, `https://raw.githubusercontent.com/beamable/Changelogs/${env}/com-beamable-server-changelog.md`)
    var beamableCliChanges = await getChanges(OWNER_CLI, `https://raw.githubusercontent.com/beamable/Changelogs/${env}/beamable-tools-changelog.md`)
    var beamableServerRuntimeChanges = await getChanges(OWNER_SDK_SERVER_RUNTIME, `https://raw.githubusercontent.com/beamable/Changelogs/${env}/beamable-server-changelog.md`)
    var beamableWebSdkChanges = await getChanges(OWNER_WEB_SDK, `https://raw.githubusercontent.com/beamable/Changelogs/${env}/beamable-web-sdk-changelog.md`)
    var beamablePortalChanges = await getChanges(OWNER_PORTAL, `https://raw.githubusercontent.com/beamable/Changelogs/${env}/com-beamable-portal-changelog.md`)
    var beamableApiChanges = await getChanges(OWNER_API, `https://raw.githubusercontent.com/beamable/Changelogs/${env}/beamable-api.md`)

    var allChanges = document.createElement('div');
    allChanges.appendChild(beamableChanges);
    allChanges.appendChild(beamableCliChanges);
    allChanges.appendChild(beamableServerChanges);
    allChanges.appendChild(beamableServerRuntimeChanges);
    allChanges.appendChild(beamableWebSdkChanges);
    allChanges.appendChild(beamablePortalChanges);
    allChanges.appendChild(beamableApiChanges);


    var changeItems = allChanges.querySelectorAll('li');
    data = {}
    for (var i = 0 ; i < changeItems.length; i ++){
      var item = changeItems[i];
 
      var version = item.attributes['version'].value;
      var releaseDate = item.attributes['release-date'].value;
      var releaseDateTooltip = item.attributes['release-date-tooltip'].value;
      var type = item.attributes['change-type'].value;
      var html = item.innerHTML;
      var owner = item.attributes['owner'].value;
      // html = `<span>${item.attributes['owner'].value}</span>` + html; 

      var major = Number(item.attributes['major'].value);
      var minor = Number(item.attributes['minor'].value);
      var patch = Number(item.attributes['patch'].value);

      var showTag = true;
      var tags = []
      var key = version; // legacy 1.0 versions are aligned, so they are all together. 
      if (major >= 2 || (major == 0 && minor == 0)){

        if (owner == OWNER_SDK_SERVER_RUNTIME || owner == OWNER_CLI){
          // showTag = true;
          // key = `${OWNER_CLI} ${version}`;
          key = `CLI & Server ${version}`;
        } 
        else if (owner == OWNER_SDK || owner == OWNER_SDK_SERVER){
          key = `Unity SDK ${version}`; // even in 2.0, com.beamable and com.beamable.server are together. 
        
        } else {
          showTag = false;
          key = `${owner} ${version}`; // starting in 2.0 versions are split.
        }
      }
      
      // handle web sdk separately
      if (owner == OWNER_WEB_SDK){
        key = `Web SDK ${version}`;
      }

      if (owner == OWNER_PORTAL){
        key = `Portal ${version}`;
      }

      if (owner == OWNER_API){
        key = `API ${version}`;
      }

      var entry = data[key];
      if (!entry){
        entry = data[key] = {
          owner: owner,
          title: key,
          showTag: showTag,
          versionField: version,
          releaseDate: releaseDate,
          releaseDateTooltip: releaseDateTooltip,
          major: major,
          minor: minor,
          patch: patch,
          changed: [],
          fixed: [],
          added: [],
          removed: [],
          issues: [],
          addedAnchor: `${version}-added`,
          fixedAnchor: `${version}-fixed`,
          changedAnchor: `${version}-changed`,
          removedAnchor: `${version}-removed`,
          issueAnchor: `${version}-issues`,
        }
      };
      if (html.endsWith('>no changes</span>')) continue;
      if (!type || type == 'undefined') continue;

      entry[type].push({
        html: html,
        owner: owner,
        anchor: `${version}-${type}-${entry[type].length}`
      })
    }

    entries = Object.entries(data).map(args => ({version: args[0], ...args[1]})).sort(dateSorter);
   

    var startHash = window.location.hash;
    window.location.hash = '';
    setTimeout( () => {
      window.location.hash = startHash;
      setTimeout(() => {
        document.getElementsByTagName("html")[0].style['scroll-behavior'] = "smooth";
      }, 5)
    }, 10)
  }

  load();

  function r(min, max) { return Math.floor(min + Math.random() * (max-min)) }

  function getLinePath(index){
    return `M0 .48c327.1 ${r(-10,20)} ${r(250,350)} ${r(60,80)} ${r(420,490)} 124.17S655.43 ${r(30,90)} ${r(860,940)} ${r(30,90)}.86s204.43 ${r(30,90)} ${r(330,390)}.56 59.79S1405.76-8.64 ${r(1630,1690)}.49.48s${r(120,170)}.28 ${r(200,250)}.34 ${r(120,220)}.28 225.34H0z`
  }

  function goHome(){
    window.location.hash = ''
    window.location.hash = 'home'
  }

</script>

  <div class="logo" style="padding-bottom:40px;">
    <img src="https://beamable.com/wp-content/uploads/2021/11/beamable-logo.svg" alt="beamable-logo"/>
    
    <div style="display:flex; align-items: end; border-bottom: solid 1px white;">
      <h1 id="home" style="flex-grow: 1; margin-bottom: 12px;"> Change Logs </h1>
    </div>
    <div style="text-align: start" class="tab-container">
      <!-- <a id="docs-link" style="margin-bottom: 2px; color: white" target="none" href="https://docs.beamable.com/docs/installing-beamable">
        Check out the Unity Beamable SDK Docs.
      </a> -->

      {#if !noSelection}
        {#each tabs as tab}
          <span class="tab" class:active={tab.active} on:click={() => tab = clickTab(tab)} title={tab.link}>
            {tab.name}
            {#if tab.link}
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M3.9,12C3.9,10.29 5.29,8.9 7,8.9H11V7H7A5,5 0 0,0 2,12A5,5 0 0,0 7,17H11V15.1H7C5.29,15.1 3.9,13.71 3.9,12M8,13H16V11H8V13M17,7H13V8.9H17C18.71,8.9 20.1,10.29 20.1,12C20.1,13.71 18.71,15.1 17,15.1H13V17H17A5,5 0 0,0 22,12A5,5 0 0,0 17,7Z" /></svg>
            {/if}
          </span>
        {/each}
      {/if}
      
    </div>

  </div>

  <svelte:window bind:scrollY={scrollY}/>

  <div id="top-button" style=" z-index: 10000;" class:shown={scrollY > 450}>
    <button on:click={goHome}>
      Back to the top
    </button>
  </div>

  {#each decorations as decoration}
  <div class="decoration" style="right: {decoration.right}; top:{(scrollY*decoration.speed)+decoration.y}px; ">
  <img 
    style="width: {decoration.width}; transform: rotate({scrollY*decoration.rotSpeed + decoration.rotStart}deg);"
    src={decoration.url}
    alt="decoration"/>
  </div>
  {/each}


  {#if noSelection}
    <div style="text-align: center; padding-top:40px; padding-bottom:40px;">
      <p>
        Welcome to the changelogs! <br>
        Select which changelogs you want to see.
      </p>

      <div style="text-align: start; display: flex" class="tab-container no-selection">
        <!-- <a id="docs-link" style="margin-bottom: 2px; color: white" target="none" href="https://docs.beamable.com/docs/installing-beamable">
          Check out the Unity Beamable SDK Docs.
        </a> -->
  
        {#each tabs as tab}
          <span class="tab" class:active={tab.active} on:click={() => tab = clickTab(tab)} title={tab.link}>
            {tab.name}
            {#if tab.link}
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M3.9,12C3.9,10.29 5.29,8.9 7,8.9H11V7H7A5,5 0 0,0 2,12A5,5 0 0,0 7,17H11V15.1H7C5.29,15.1 3.9,13.71 3.9,12M8,13H16V11H8V13M17,7H13V8.9H17C18.71,8.9 20.1,10.29 20.1,12C20.1,13.71 18.71,15.1 17,15.1H13V17H17A5,5 0 0,0 22,12A5,5 0 0,0 17,7Z" /></svg>
            {/if}
          </span>
        {/each}
        
      </div>
    
    </div>
    {:else}
    
    <div class="entries">
      {#each filteredEntries as entry, index}

        <!-- {#if index > 0 && filteredEntries[index-1].major == 2 && entry.major == 1}
        <div class="entry" class:flip={index%2 == 0} >
          <div class="entry-content">

            <div class="pre-2-0-message">
              <span>
                Before Beamable 2.0, the Unity SDK and CLI were always released together and they shared an aligned version number. The following changelogs show the interlaced changes from the Unity SDK and CLI. 
              </span>
            </div>
          </div>

        </div>
        {/if} -->

        <div class="entry" class:flip={index%2 == 0}>
          {#if index > 0}

            {#if index%3==1}
            <svg version="3" class="gloopy-bg bg-blue"  class:flip={index%2 != 0} class:mirror={index%2==1} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1832 189"><path d="M999.3 1.5C995 3.4 992 8.4 992 13.8c0 5.8 2.5 9.8 7.7 12.3 11.9 5.8 23.8-7.2 17.5-19-3.4-6.2-11-8.6-17.9-5.6zM1047.9 26.5c-7 2.2-14 7.4-17.3 12.8-5.2 8.5-3.5 19.7 4.1 26.9 11.1 10.5 32.7 11.8 45.1 2.8 21.4-15.5 9.5-42.6-19.3-43.7-5.1-.2-9.7.3-12.6 1.2z"></path><path d="M0 115v74h1832V40.8l-7.7.7c-18.7 1.7-33.7 7.3-61.1 22.7-45.6 25.8-67.4 35.1-100.5 43.3-30.1 7.3-53.4 10.1-95.2 11.5-42.4 1.3-51 1.8-68 4-20.6 2.7-38.7 6.1-60.5 11.6-29.4 7.3-44 7-64.5-1.5-17.6-7.2-30-15.8-63.3-43.8-31.8-26.8-47.7-37.2-65.7-43.2-29.3-9.7-62.3-4.9-90.2 13.1-3.7 2.5-14.1 9.9-23 16.5-24.1 18-34.2 23.6-51.3 27.9-5.9 1.5-10.8 1.9-23.5 1.8-24.5-.1-39.6-3.9-68-17.1C946.1 68.2 930 63.9 898 63.9c-27.5 0-41.6 3.5-102 25.4-50.3 18.2-83.4 26.3-125.5 30.9-19.3 2.1-67.9 1.6-101.5-1-28.7-2.2-79.6-5.3-118.5-7.2-36.1-1.8-101.6-2.4-115-1.1-16.8 1.6-35.7 5.6-83 17.6-52.3 13.2-60.1 14.3-78.6 11-26.2-4.6-43.2-15.2-80.8-50.4C81.3 78 68.5 66.5 64.6 63.5 44.5 48.1 26.1 41.1 5.8 41H0v74z"></path><path d="M308.5 51.1c-9.4 8.3-5 22.5 7.4 23.7 11.1 1 18.2-9.4 13.4-19.5-2.2-4.7-6.6-7.3-12.5-7.3-3.9 0-5.4.6-8.3 3.1zM1702.3 54.4c-3 2.7-3.7 4.1-3.7 7 0 5.3 3.1 8.1 9.2 8.1 5.9 0 9.8-2.4 11.8-7.2 2.7-6.5-1-11.3-8.8-11.3-4.1 0-5.4.5-8.5 3.4zM1646.7 65.6c-6.5 2-13.2 8.7-14.1 14.1-1.7 9.5 6 16.3 18.1 16.3 16-.1 27.1-13.5 20.4-24.6-3.7-6.1-15-8.8-24.4-5.8zM176.4 81c-16.1 5.3-23.5 19.9-16.6 33 9.8 18.9 44.1 20.2 56.7 2.1 3.9-5.8 4.7-14.8 1.7-20.7-5-9.8-14.6-15.4-27.5-16-6.3-.3-9.6 0-14.3 1.6zM632 80c-11.2 2.4-18.9 8.7-17.4 14.4 2.8 11.2 34 16.1 50.3 7.9 12.7-6.4 11.6-14.9-2.8-20.4-6.4-2.5-22.5-3.5-30.1-1.9z"></path></svg>
            {:else}
          
            <svg class="gloopy-bg odd" class:flip={index%2 != 0} class:mirror={index%2==1} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1700 225.82"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><g id="Group_583" data-name="Group 583">
              <path id="Path_872" data-name="Path 872" class="cls-1" d={getLinePath(index)}></path>
              <!-- <path id="Path_872" data-name="Path 872" class="cls-1" d="M0 .48c327.1 10 307.69 87.38 463.65 124.17S655.43 62.56 899.9 64.86s204.43 69 383.56 59.79S1405.76-8.64 1656.49.48s162.28 225.34 162.28 225.34H0z"></path> -->
            
              {#if index%5 == 2}
                <ellipse id="Ellipse_177" data-name="Ellipse 177" class="cls-1" cx={r(485, 515)} cy={r(65, 75)} rx={r(37, 60)} ry={r(20, 40)}></ellipse>
              {/if}
              {#if index%3==1}
                <ellipse id="Ellipse_178" data-name="Ellipse 178" class="cls-1" cx={r(1155, 1170)}  cy={r(85, 95)} rx={r(14, 17)} ry={r(10, 15)}></ellipse>
              {/if}
              {#if Math.random() > .5}
                <ellipse id="Ellipse_179" data-name="Ellipse 179" class="cls-1" cx={r(1210, 1240)} cy={r(100, 115)}  rx={r(8, 11)} ry={r(9, 11)}></ellipse>
              {/if} 
            </g></g></g></svg>
            {/if}
          {/if}
          <div class="entry-content" show-tag={entry.showTag}>
            <div>
              <h2 id={entry.version}>
                <a class="link-anchor" href={'#' + entry.version}>
                  <img alt="link" src='https://cdn.iconscout.com/icon/free/png-256/link-1912222-1617691.png'/>
                </a>

                <span>
                  <span class="entry-title">
                    {entry.version}
                  </span>
                  {#if blogPosts[entry.version]}
                    <a class="blog-post-link" target="none" href={blogPosts[entry.version].url}>{blogPosts[entry.version].desc}</a>
                  {/if}
                  
                  {#if entry.releaseDate}
                    <br>
                    <span class="release-date" title={entry.releaseDateTooltip}>
                      {entry.releaseDate}
                    </span>
                  {/if}
                </span>
                <br>
                
              </h2>
              <div class="section-content">
                  {#if !(entry.added.length + entry.removed.length + entry.fixed.length + entry.changed.length)}
                    <p class="no-content"> This release contains no changes. </p>
                  {/if}
                  {#if entry.issues.length}
                    <h3 id={entry.issuesAnchor}>
                      <a class="link-anchor" href={'#' + entry.issuesAnchor}>
                        <img alt="link" src='https://cdn.iconscout.com/icon/free/png-256/link-1912222-1617691.png'/>
                      </a>
                      Known Issues
                    </h3>
                    <ul>
                      {#each entry.issues as item}
                        <div class="link-item" owner={item.owner}>
                          <a class="link-anchor" href={'#' + item.anchor}>
                            <img alt="link" src='https://cdn.iconscout.com/icon/free/png-256/link-1912222-1617691.png'/>
                          </a>
                          <li owner={item.owner} id={`${item.anchor}`} >
                            {@html item.html}
                          </li>
                        </div>
                      {/each}
                    </ul>
                  {/if}
                  {#if entry.added.length}
                    <h3 id={entry.addedAnchor}>
                      <a class="link-anchor" href={'#' + entry.addedAnchor}>
                        <img alt="link" src='https://cdn.iconscout.com/icon/free/png-256/link-1912222-1617691.png'/>
                      </a>
                      Added
                    </h3>
                    <ul>
                      {#each entry.added as item}
                        <div class="link-item" owner={item.owner}>
                          <a class="link-anchor" href={'#' + item.anchor}>
                            <img alt="link" src='https://cdn.iconscout.com/icon/free/png-256/link-1912222-1617691.png'/>
                          </a>
                          <li owner={item.owner} id={`${item.anchor}`} >
                            {@html item.html}
                          </li>
                        </div>
                      {/each}
                    </ul>
                  {/if}
                  {#if entry.fixed.length}
                    <h3 id={entry.fixedAnchor}>
                      <a class="link-anchor" href={'#' + entry.fixedAnchor}>
                        <img alt="link" src='https://cdn.iconscout.com/icon/free/png-256/link-1912222-1617691.png'/>
                      </a>
                      Fixed
                    </h3>
                    <ul>
                      {#each entry.fixed as item}
                        <div class="link-item" owner={item.owner}>
                          <a class="link-anchor" href={'#' + item.anchor}>
                            <img alt="link" src='https://cdn.iconscout.com/icon/free/png-256/link-1912222-1617691.png'/>
                          </a>
                          <li owner={item.owner} id={`${item.anchor}`} >
                            {@html item.html}
                          </li>
                        </div>
                      {/each}
                    </ul>
                  {/if}
                  {#if entry.changed.length}
                    <h3 id={entry.changedAnchor}>
                      <a class="link-anchor" href={'#' + entry.changedAnchor}>
                        <img alt="link" src='https://cdn.iconscout.com/icon/free/png-256/link-1912222-1617691.png'/>
                      </a>
                      Changed
                    </h3>
                    <ul>
                      {#each entry.changed as item}
                        <div class="link-item" owner={item.owner}>
                          <a class="link-anchor" href={'#' + item.anchor}>
                            <img alt="link" src='https://cdn.iconscout.com/icon/free/png-256/link-1912222-1617691.png'/>
                          </a>
                          <li owner={item.owner} id={`${item.anchor}`} >
                            {@html item.html}
                          </li>
                        </div>
                      {/each}
                    </ul>
                  {/if}
                  {#if entry.removed.length}
                    <h3 id={entry.removedAnchor}>
                      <a class="link-anchor" href={'#' + entry.removedAnchor}>
                        <img alt="link" src='https://cdn.iconscout.com/icon/free/png-256/link-1912222-1617691.png'/>
                      </a>
                      Removed
                    </h3>
                    <ul>
                      {#each entry.removed as item}
                        <div class="link-item" owner={item.owner}>
                          <a class="link-anchor" href={'#' + item.anchor}>
                            <img alt="link" src='https://cdn.iconscout.com/icon/free/png-256/link-1912222-1617691.png'/>
                          </a>
                          <li owner={item.owner} id={`${item.anchor}`} >
                            {@html item.html}
                          </li>
                        </div>
                      {/each}
                    </ul>
                  {/if}
              </div>
            </div>
          </div>
        </div>

        <!-- <svg class="gloopy-bg even" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1700 225.82"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><g id="Group_583" data-name="Group 583"><path id="Path_872" data-name="Path 872" class="cls-1" d="M0 .48c327.1 0 307.69 87.38 463.65 124.17S655.43 62.56 899.9 64.86s204.43 69 383.56 59.79S1405.76-8.64 1656.49.48s162.28 225.34 162.28 225.34H0z"></path><ellipse id="Ellipse_177" data-name="Ellipse 177" class="cls-1" cx="511.45" cy="70.25" rx="68.5" ry="35.5"></ellipse><ellipse id="Ellipse_178" data-name="Ellipse 178" class="cls-1" cx="1166.45" cy="85.25" rx="15.5" ry="13.5"></ellipse><ellipse id="Ellipse_179" data-name="Ellipse 179" class="cls-1" cx="1212.45" cy="98.25" rx="9.5" ry="8.5"></ellipse></g></g></g></svg> -->
      {/each}
      <div style="text-align: center; padding-top:40px; padding-bottom:40px;">
        <p>
          Those are all the changelogs.<br>
          Reach out to us on <a style="color: white;" href="https://discord.com/invite/beamable">Discord</a>
        </p>
      
      </div>
    </div>

  {/if}

<style>

@media only screen and (max-width: 800px) {
  .decoration {
    display: none;
  }
  .logo {
    margin-left: 20px !important;
    width: calc(100% - 40px) !important;
  }
  .entry-content > div{
    margin-left: 5px !important;
    width: calc(100% - 10px) !important;
  }
  h2 span a {
    font-size: 3vw !important;
    white-space: nowrap;
  }
  #top-button {
    left: 15px  !important;
    right: 15px  !important;
    display: flex;
  }
  #top-button button {
    flex-grow: 1;
  }
  .entry-title {
    font-size: 24px;
  }
}

  :global(.item-owner) {
    opacity: .8;
    font-family: monospace;
    /* min-width: 30px; */
  }

  @keyframes bounce {
    0%   {transform: translateY(0px);}
    33%  {transform: translateY(10px);}
    66%  {transform: translateY(5px);}
    100% {transform: translateY(0px);}
  }

  .tab-container {
    display: flex;
    padding-top: 12px;
    --tab-active: rgba(255,255,255,.8);
    --tab-inactive: rgba(0,0,0,.8);
  }
  .tab-container.no-selection {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  .tab {
    display: flex;
    align-items: center;
    border: solid 1px;
    border-color: var(--tab-active);
    border-radius: 20px;
    padding: 4px 8px;
    color: var(--tab-active);
    cursor: pointer;
    margin: 0px 4px;
    transition: background-color linear .1;
  }
  .tab > svg {
    height: 24px;
    background-color: transparent !important;
    left: 2px;
  }
  .tab > svg path {
      stroke: transparent;
      fill: rgba(255,255,255,.7);
    }
  .tab.active {
    color: var(--tab-inactive);
    background-color: var(--tab-active);
  }

  .tab.active:hover {
    background-color: rgba(255, 255, 255, .5);
  }
  .tab:hover {
    background-color: rgba(255, 255, 255, .2);
  }

  .decoration {
    position: absolute; 
    z-index: 1;
    filter: drop-shadow(2px 4px 13px rgba(0,0,0,.2));
    opacity: .8;
    animation-name: bounce;
    animation-duration: 4s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
  }

  .logo {
    padding-top:40px;
    padding-bottom: 60px;
    width: calc(70% - 40px);
    /* margin: auto; */
    margin-left: 15%;
  }
  .logo img {
    filter: drop-shadow(2px 4px 13px rgba(0,0,0,.4));
  }
  #docs-link {
    text-decoration: none;
    text-shadow: 2px 2px 4px rgba(0,0,0,.7);
    opacity: .8;
  }
  #docs-link:hover {
    opacity: 1;
  }

  .entry-content > div {
    margin-left: 15%;

    width: 70%;
  }

  a {
    scroll-padding-top: 2em;
  }

  :global(a:hover){
    opacity: 1;
  }
  :global(a:visited)
  {
    color: var(--highlight-color);
  }

  :global(a)
  {
    color: var(--highlight-color);
    opacity: .8;
  }

  .release-date {
    font-size: .5em;
    padding-left: 35px;
    padding-top: 12px;
    opacity: .7;
  }
/*   
  .flip div[owner="com.beamable.server"]::before{
    opacity: .5;
  }
  .flip div[owner="com.beamable"]::before{
    opacity: .5;

  }

  div[owner="com.beamable.server"]::before{
    content: '';
    position: relative;
    border-left: solid 3px white;
    margin-top:5px;
    opacity: .8;
  }

  div[owner="com.beamable"]::before{
    content: '';
    position: relative;
    border-left: solid 3px #179aff;
    opacity: .8;

  }
  div[owner="com.beamable"]+div[owner="com.beamable.server"]::before {
    margin-top: 5px;
  }
  div[owner="com.beamable.server"]~div[owner="com.beamable.server"]::before {
    margin-top: 0px;
  } */


  ul {
    margin-bottom: 0px;
    padding-left: 0px;
  }

  .link-item {
    display: flex;
  }

  .entry:not(.flip) .entry-content {
    background-color: var(--color2);
    min-height: 20vh;
    padding-bottom: 30px;

  }

  svg.mirror {
    transform: scaleX(-1);
  }
  svg {
    position: relative;
    background-color: transparent;
    fill: #292F36;
  }

  svg:not(.flip) {
    fill: var(--color1);
    background-color: var(--color2);
  }
  svg.flip {
    top:30px;
    fill: var(--color2);
  }

  .section-content {
    z-index: 100;
    position: relative;
  }

  .link-item > * {
    margin-left: 20px;
  }

  .link-item:hover .link-anchor,
  h3:hover .link-anchor,
  h2:hover .link-anchor {
    visibility: visible;
  }
  .link-anchor {
    visibility: hidden;
  }

  *:hover > .link-anchor img {
    display: inline-block;
  }
  *:not(:hover) > .link-anchor {
    min-width: 20px;
    display: inline-block;
    max-height: 20px;
  }
  .link-anchor img {
    filter: invert();
    height: 20px;
    max-height: 20px;
    width: 20px;
    display: none;
    padding: 0px;
    margin: 0px;
  }

  .no-content {
    margin-left: 30px;
    opacity: .8;
  }

  a:visited,
  a:active,
  a:link {
    color: black;
    height: 20px;
  }


  h1 {
    letter-spacing: 4px;
  }

  h2 {
    margin-top: 0px;
    padding-top:30px;
    font-size: 2.2em;
    font-weight: bold;
    position: relative;
    left:-10px;
  }
  h3 {
    font-size: 1.5em;
  }

  :global(*){
    --highlight-color: #adfff9;
  }
  :global(.entry-content[show-tag=false] .item-owner) {
    display:none;
  }
  :global(code) {
    color: var(--highlight-color);
    word-break: break-word;
  }
  p, li,
  h2, h3, h1 {
    color: white;
    text-shadow: 2px 2px 4px rgba(0,0,0,.7);
    word-break: break-word;
  }

  li {
    color: white;
  }

  #top-button {
    opacity: 0;
    transition: opacity .05s ease-in-out;
    z-index: -1;
    position: fixed; left: 15px; bottom: 15px;
  }
  #top-button.shown {
    opacity: 1;
    transition: opacity .25s ease-in-out;
    z-index: 10000;
  }
  #top-button button {
    background: #297cddab;
    color: white;
    border: none;
    cursor: pointer;
    box-shadow: 0 0 12px -4px rgb(0 0 0 / 70%);
    padding: 12px;
    border-radius: 30px;
    font-weight: bold;
  }
  #top-button button:hover {
    background: #278bffab;;
  }

    a.blog-post-link:visited,
    a.blog-post-link:active,
    a.blog-post-link:link,
  .blog-post-link {
    color: white;
    opacity: .7;
    text-decoration: none;
    /* float: right; */
    margin-left: 8px;
    font-size: .5em;
  }
  a.blog-post-link:hover {
    opacity: 1;
  }

  .pre-2-0-message {
    color: white;
    border-bottom: 1px solid rgba(255, 255, 255, .5);
    padding-bottom: 10px;
    padding-top: 100px;
    margin-bottom: 20px;
    text-shadow: 2px 2px 4px rgba(0,0,0,.7);
    font-weight: bold;
  }
  
</style>
